import React from 'react';

import { EMPLOYEE_PAY_EDIT } from 'src/constants/EndpointUrls';
import { SearchReactSelect, ConfirmedOptionRenderer } from 'src/components';
import { formatDate } from 'src/utils/Date';
import { redirectTo, concatParamsToUrl } from 'src/utils/Http';
import styles from './AllPays.scss';
import { useTranslation } from 'react-i18next'

const buildTimeString = employeePay => {
  const { t } = useTranslation();
  let str = '';
  // if (employeePay.targetStartDate) {
  //   str += `対象期間 ${formatDate(employeePay.targetStartDate)} 〜 ${formatDate(employeePay.targetEndDate)}`;
  // }
  if (employeePay.attendanceTargetStartDate && employeePay.attendanceTargetStartDate !== employeePay.targetStartDate) {
    str += `${t("features.EmployeePays.components.EmployeePayForm.Attendance_target_period")}: ${formatDate(employeePay.attendanceTargetStartDate)} ~ ${formatDate(
      employeePay.attendanceTargetEndDate
    )}`;
  }
  return (
    <React.Fragment>
      <div>{str}</div>
      <div className={styles.paymentDate}>{`${t("features.EmployeePays.components.EmployeePayForm.Payment_date")}: ${formatDate(employeePay.paymentDate)}`}</div>
    </React.Fragment>
  );
};

const redirectToPayDetail = payId => redirectTo(concatParamsToUrl(EMPLOYEE_PAY_EDIT, { id: payId }));

const AllPays = ({ allEmployeePays = [], employeePay }) => (
  <React.Fragment>
    <div className={styles.center}>
      <SearchReactSelect
        value={employeePay.id}
        options={allEmployeePays.map(pay => ({ value: pay.id, label: pay.labelWithClosing, confirmed: pay.confirmed }))}
        onChange={pay => redirectToPayDetail(pay.value)}
        width={350}
        size="large"
        cache={false}
        optionRenderer={option => <ConfirmedOptionRenderer option={option} />}
      />
    </div>
    <div className={styles.month}>
      <div className={styles.monthCaption}>{buildTimeString(employeePay)}</div>
    </div>
  </React.Fragment>
);

export default AllPays;
